var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"map-route-legend"},_vm._l((_vm.items),function(item,index){return _c('div',{key:'legend-' + index + '-' + item.label,staticClass:"map-route-legend-item"},[_c('span',{staticClass:"map-route-legend-swatch",style:({
        backgroundColor: item.color,
        height: Math.max(item.lineWidth, 3) + 'px',
      })}),_c('span',{staticClass:"map-route-legend-label"},[_vm._v(_vm._s(item.label))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }